import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    versions: {
      marginTop: '15px',
      marginBottom: '15px',
      width: '100%',
      '& th': {
        backgroundColor: '#cccccc',
        textAlign: 'left',
        padding: '4px 0px 4px 10px',
      },
      '& tr': {
        lineHeight: '30px',
        backgroundColor: '#f2f2f2',
      },
      '& td': {
        paddingLeft: '10px',
      },
    },
  },
  {
    name: 'VersionsTable',
  },
);
